//---------------------------------------------------
//  Nom du fichier : Icon.js 
//
//  Description: Fichier qui crée les icon pour la map
//               cluster et icon de localisation       
//
//  Auteur: Alek Del Balso
//---------------------------------------------------

import L from 'leaflet';
import './Icon.css'

const createColorIcon = (iconUrl) => new L.Icon({
    iconUrl: iconUrl,
    iconAnchor: [25, 50],
    popupAnchor: [0, -50],
    iconSize: [50, 50]
});

const createClusterCustomIcon = function (cluster) {
    return L.divIcon({
      html: `<span'>${cluster.getChildCount()}</span>`,
      className: 'marker-cluster-custom',
      iconSize: L.point(40, 40, true),
      iconUrl:require('./Images/test_icon.png')
    });
}
  

export {createColorIcon, createClusterCustomIcon};